<template>
  <div class="plug_download">
    <div class="download_title">
      晓风插件<br />
      -让运营变得更高效
    </div>
    <div class="item_list">
      <div class="item" v-for="(item,index) in itemList" :key="index">
        {{ item }}
      </div>
    </div>
    <div class="download_btns">
      <div class="default_btn">
        <a class="default_a_tag" :href="baseCrxUrl">
          <img class="browser_icon" :src="currentBrowser.url" alt="">
          <div>当前浏览器</div>
          <img class="download_icon" src="@/assets/download_white.png" alt="">
        </a>
      </div>
      <div class="other_btn" style="margin: 16px 0;">
        <a class="a_tag" :href="e360CrxUrl">
          CRX 插件下载新版
          <img class="download_icon" src="@/assets/download_blue.png" alt="">
        </a>
        <img class="special" src="@/assets/360_special.png" alt="">
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import browser360 from '@/assets/browser/360.png'
import browserUc from '@/assets/browser/uc.png'
import browser360jisu from '@/assets/browser/360_jisu.png'
import browserQq from '@/assets/browser/qq.png'
import browser2345 from '@/assets/browser/2345.png'
import browserSougou from '@/assets/browser/sougou.png'
import browserChrome from '@/assets/browser/chrome.png'
import browserEdge from '@/assets/browser/edge.png'
import defaultBrowser from '@/assets/browser/default_browser.png'
// import { GetBrowserType } from '@/api/browser';

const itemList = ref([
  'AI爆款裂变',
  'AI换主图',
  'AI换标题',
  'AI商品违规检测',
  '榜单截流',
  '批量铺货',
  '全自动下单',
])
// const baseCrxUrlV2 = `https://dyorder.xiaofengshop.cn/download/file/晓风一键下单(抖音)V12.8.crx`
const baseCrxUrl = `https://xfdyorder.zzbtool.com/download/file/晓风电商助手正式版30.3.3.zip`
const e360CrxUrl = `https://xfdyorder.zzbtool.com/download/file/晓风电商助手正式版30.3.3.crx`


const currentBrowser = ref({})

onMounted(() => {
  currentBrowser.value = detectSpecialBrowser()
})

const detectSpecialBrowser = () => {
  const ua = navigator.userAgent
  let name = '未知浏览器'
  let url = ''
  if (/2345Explorer|Mb2345Browser/.test(ua)) {
    name = '2345浏览器'
    url = browser2345
  }
  else if (/MetaSr|Sogou/.test(ua)) {
    name = '搜狗浏览器'
    url = browserSougou
  }
  else if (/QQBrowser/.test(ua)) {
    name = 'QQ浏览器'
    url = browserQq
  }
  else if (/UCBrowser/.test(ua)) {
    name = 'UC浏览器'
    url = browserUc
  }
  else if (/360EE/.test(ua)) {
    name = '360极速浏览器'
    url = browser360jisu
  }
  else if (/360SE/.test(ua)) {
    name = '360浏览器'
    url = browser360
  }
  else if (/Edg\/|Edge\/\d+/.test(ua)) {
    name = 'Edge'
    url = browserEdge
  }
  else if (/Chrome/.test(ua) && !/Edg|OPR|360|QQ|MetaSr|2345/.test(ua)) {
    name = '谷歌浏览器'
    url = browserChrome
  }
  else {
    url = defaultBrowser
  }
  return {name, url}
}

</script>

<style lang="less" scoped>
@import './index.less';
</style>